export const individualMapping = {
  if: `Si`,
  apply_conditions: `Aplicar condiciones`,
  add_another_condition: `Agregar otra condición`,
  field_name: `Nombre del campo`,
  select_field: `Seleccionar campo`,
  is: `Es`,
  select_operator: `Seleccionar operador`,
  enter_value_condition: `Ingresar valor`,
  and: `Y`,
  map_values: `Mapear valores`,
  add_another_mapping: `Agregar otro mapeo`,
  set: `Establecer`,
  target_field: `Campo destino`,
  select_target_field: `Seleccionar campo destino`,
  direct_value: `Valor directo`,
  field_value_type: `Campo`,
  formula_value_type: `Fórmula`,
  insert_a_field: `Insertar un campo`,
  formula_operator_add: `Sumar`,
  formula_operator_subtract: `Restar`,
  formula_operator_multiply: `Multiplicar`,
  formula_operator_divide: `Dividir`,
};
